const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4001/api';

// Get current user's token usage
export const getMyUsage = async (startDate = null, endDate = null) => {
  try {
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate.toISOString());
    if (endDate) params.append('endDate', endDate.toISOString());
    
    const response = await fetch(`${API_BASE_URL}/usage/my-usage?${params}`, {
      credentials: 'include',
    });
    if (!response.ok) throw new Error('Failed to fetch usage');
    return await response.json();
  } catch (error) {
    console.error('Error fetching usage:', error);
    throw error;
  }
};

// Get all users' token usage (admin only)
export const getAllUsersUsage = async (startDate = null, endDate = null) => {
  try {
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate.toISOString());
    if (endDate) params.append('endDate', endDate.toISOString());
    
    const response = await fetch(`${API_BASE_URL}/usage/all-users?${params}`, {
      credentials: 'include',
    });
    if (!response.ok) throw new Error('Failed to fetch all users usage');
    return await response.json();
  } catch (error) {
    console.error('Error fetching all users usage:', error);
    throw error;
  }
};

// Get usage by model
export const getUsageByModel = async (startDate = null, endDate = null) => {
  try {
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate.toISOString());
    if (endDate) params.append('endDate', endDate.toISOString());
    
    const response = await fetch(`${API_BASE_URL}/usage/by-model?${params}`, {
      credentials: 'include',
    });
    if (!response.ok) throw new Error('Failed to fetch usage by model');
    return await response.json();
  } catch (error) {
    console.error('Error fetching usage by model:', error);
    throw error;
  }
};

// Get user's remaining credits
export const getUserCredits = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/usage/credits`, {
      credentials: 'include',
    });
    if (!response.ok) throw new Error('Failed to fetch credits');
    return await response.json();
  } catch (error) {
    console.error('Error fetching credits:', error);
    throw error;
  }
};